import * as React from "react"

import styles from "./image.module.scss"
import classnames from "classnames/bind"
const cx = classnames.bind(styles)

export const Image = ({ src }) => (
  <img className={cx("image")} src={src} alt="" />
)
